import { createApiResource, UnpagedListHookResult, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanBusinessUnit, ServiceTitanBusinessUnitQueryParams } from '../apiTypes.shim';

type ServiceTitanBusinessUnitResource = UnpagedListResource<
  ServiceTitanBusinessUnit,
  ServiceTitanBusinessUnitQueryParams
> & {
  useUnpagedListCached: () => UnpagedListHookResult<ServiceTitanBusinessUnit>;
};

export const serviceTitanBusinessUnitResource = (companyId: string): ServiceTitanBusinessUnitResource => {
  const businessUnitUri = `${companyId}/business-units`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(ServiceTitanAPI, businessUnitUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey,
    useUnpagedListCached: () => useUnpagedList({}, { refetchOnMount: false })
  };
};
